type TimeUnit = 'hours' | 'minutes' | 'seconds'

export function toMs(value: number, unit: TimeUnit): number {
  switch (unit) {
    case 'hours':
      return value * 60 * 60 * 1000
    case 'minutes':
      return value * 60 * 1000
    case 'seconds':
      return value * 1000
  }
}

export const FIVE_SECONDS = toMs(5, 'seconds')
export const ONE_MINUTE = toMs(1, 'minutes')
export const FIVE_MINUTES = toMs(5, 'minutes')
export const THIRTY_MINUTES = toMs(30, 'minutes')
export const ONE_HOUR = toMs(1, 'hours')
